import React, { useState, useEffect } from "react";

const STORAGE_KEY = "fk_storage_messagebanner";

export default function MessageBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (typeof window === "undefined") return;
      const stored = window.localStorage.getItem(STORAGE_KEY);
      setVisible(!(stored === "close"));
    } catch (error) {
      console.error("MessageBanner: localStorage error", error);
      setVisible(true);
    }
  }, []);

  const handleChoice = (choice) => {
    try {
      if (typeof window !== "undefined") {
        window.localStorage.setItem(STORAGE_KEY, choice);
      }
    } catch (error) {
      console.error("MessageBanner: save error", error);
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      {/* MOBILE (< md) */}
      <div className="fixed bottom-5 mx-5 z-[100] md:hidden">
        <div className="relative">
          <div className="w-full py-4 flex items-end justify-between bg-white/10 backdrop-blur-xl border border-white/20 text-slate-200 rounded-3xl p-5 shadow-2xl overflow-visible">
            <div className="flex-1 text-sm leading-relaxed text-slate-300">
              <p className="tracking-wide text-[11px]">
                I've been watching every move you make. You're getting better,
                almost worthy of my attention. But don't get comfortable. One
                mistake is all it takes to lose everything.
              </p>

              <div className="mt-3 flex gap-3">
                <button
                  onClick={() => handleChoice("close")}
                  className="px-3 py-1.1 text-sm font-semibold text-white bg-gradient-to-r from-indigo-500 to-purple-500 rounded-xl shadow-[inset_0_1px_0_rgba(255,255,255,0.2)] hover:shadow-[0_0_10px_rgba(139,92,246,0.4)] transition-all duration-300 hover:scale-[1.03] active:scale-[0.98]"
                >
                  Cerrar
                </button>
              </div>
            </div>

            <div className="w-[110px] flex-shrink-0" />
          </div>

          <div className="absolute bottom-[4px] right-[-20px]">
            <div className="relative w-[160px]">
              <img
                src="/assets/images/logo.png"
                alt="Spectrum"
                className="w-full h-auto drop-shadow-xl select-none pointer-events-none [mask-image:linear-gradient(to_bottom,black_40%,transparent_100%)]"
              />
            </div>
          </div>
        </div>
      </div>

      {/* TABLET (md–lg) */}
      <div className="fixed bottom-8 right-8 z-[100] hidden md:block lg:hidden">
        <div className="relative w-[400px]">
          <div className="relative flex items-end justify-between bg-white/10 backdrop-blur-xl border border-white/20 text-slate-200 rounded-3xl p-5 shadow-2xl overflow-visible">
            <div className="flex-1 text-sm leading-relaxed text-slate-300 pr-5">
              <p className="tracking-wide text-xs">
                I've been watching every move you make. You're getting better,
                almost worthy of my attention. But don't get comfortable. One
                mistake is all it takes to lose everything.
              </p>

              <div className="mt-4 flex gap-3">
                <button
                  onClick={() => handleChoice("close")}
                  className="px-3 py-1.1 text-sm font-semibold text-white bg-gradient-to-r from-indigo-500 to-purple-500 rounded-xl shadow-[inset_0_1px_0_rgba(255,255,255,0.2)] hover:shadow-[0_0_10px_rgba(139,92,246,0.4)] transition-all duration-300 hover:scale-[1.03] active:scale-[0.98]"
                >
                  Cerrar
                </button>
              </div>
            </div>

            <div className="w-[120px] flex-shrink-0" />
          </div>

          <img
            src="/assets/images/logo.png"
            alt="Spectrum"
            className="absolute bottom-[6px] right-[-23px] w-[200px] h-auto drop-shadow-xl select-none pointer-events-none [mask-image:linear-gradient(to_bottom,black_40%,transparent_100%)]"
          />
        </div>
      </div>

      {/* DESKTOP (lg+) */}
      <div className="fixed bottom-8 right-8 z-[100] hidden lg:block">
        <div className="relative w-[400px]">
          <div className="relative flex items-end justify-between bg-white/10 backdrop-blur-xl border border-white/20 text-slate-200 rounded-3xl p-5 shadow-2xl overflow-visible">
            <div className="flex-1 text-sm leading-relaxed text-slate-300 pr-5">
              <p className="tracking-wide text-xs">
                I've been watching every move you make. You're getting better,
                almost worthy of my attention. But don't get comfortable. One
                mistake is all it takes to lose everything.
              </p>

              <div className="mt-4 flex gap-3">
                <button
                  onClick={() => handleChoice("close")}
                  className="px-3 py-1.1 text-sm font-semibold text-white bg-gradient-to-r from-indigo-500 to-purple-500 rounded-xl shadow-[inset_0_1px_0_rgba(255,255,255,0.2)] hover:shadow-[0_0_10px_rgba(139,92,246,0.4)] transition-all duration-300 hover:scale-[1.03] active:scale-[0.98]"
                >
                  Cerrar
                </button>
              </div>
            </div>

            <div className="w-[120px] flex-shrink-0" />
          </div>

          <img
            src="/assets/images/logo.png"
            alt="Spectrum"
            className="absolute bottom-[6px] right-[-23px] w-[200px] h-auto drop-shadow-xl select-none pointer-events-none [mask-image:linear-gradient(to_bottom,black_40%,transparent_100%)]"
          />
        </div>
      </div>
    </>
  );
}
